import { cn } from '../../utils/cn';

export function QuickCreateChipSelect({ options, value, onChange, ariaLabel }) {
  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label={ariaLabel}>
      {options.map((option) => {
        const selected = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={selected}
            onClick={() => onChange(option.value)}
            className={cn(
              'rounded-full px-3.5 py-2 text-[13px] font-medium transition-colors',
              selected
                ? 'bg-sage-600 font-semibold text-white dark:bg-sage-500'
                : 'bg-muted text-muted-foreground hover:bg-stone-200 dark:hover:bg-stone-700',
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
